// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popup__container-f48fe2 {
  flex: 1;
  width: 440px;
  max-height: 732px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
}

.Popup__hide-d10437 {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/popups/src/components/Popup/Popup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  width: 440px;\n  max-height: 732px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-sizing: content-box;\n}\n\n.hide {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Popup__container-f48fe2`,
	"hide": `Popup__hide-d10437`
};
module.exports = ___CSS_LOADER_EXPORT___;
